import { Api } from '../../api/models/apis';
import { castSingleColumn } from '../init-data/helpers';
import { TpDataContext, TpDerivedColumnPatch } from '../interfaces';
import { getDataTable } from '../../features/visual-analytics/charts/chartDataBindings';
import { buildDerivedColumnPatch } from '../../features/visual-analytics/actions/helpers/derivedColumnPatch';
import type { AddColumnAsync } from './schemas';

export async function fetchLazyColumnData(
  api: Api,
  dataContextId: string,
  dataTableId: string,
  columnId: string,
): Promise<string[]> {
  const presignedUrl = await api.dataContext.getDataTablePart(dataContextId, dataTableId, columnId);
  const response = await fetch(presignedUrl);
  if (!response.ok) throw new Error('Unable to fetch data from storage');
  const lines = (await response.text())
    .split('\n')
    .filter((line) => line.length > 0)
    .map((line) => line.replace('\r', ''));
  lines.shift();
  return lines;
}

export async function computeAsyncColumnPatch(
  dataContext: TpDataContext,
  api: Api,
  targetDataContextId: string,
  payload: AddColumnAsync & { targetTableId: string; targetColumnId: string },
): Promise<TpDerivedColumnPatch> {
  const targetTable = getDataTable(dataContext, payload.targetTableId);
  const rawData = await fetchLazyColumnData(api, targetDataContextId, payload.sourceDataTableId, payload.columnId);
  const metadata = payload.columnMetadata;
  const columnData = castSingleColumn(rawData, metadata.valueType);
  if (columnData.length !== targetTable.columnData[targetTable.colItemId].length)
    throw new Error('The source and target data have different row counts.');
  return buildDerivedColumnPatch(
    payload.targetTableId,
    payload.targetColumnId,
    metadata.name,
    metadata.description,
    metadata.valueType,
    metadata.groupId,
    metadata.groupName,
    metadata.groupDescription,
    columnData,
    metadata.decimalDigits,
  );
}
